import React, {useState} from 'react';
import {useDispatch} from 'react-redux';
import {Actions} from '../../../../common/actions';
import {Modal, Button, Dropdown} from 'semantic-ui-react';
import './confirmation.scss';

const {fetchAgenciesByDealer} = Actions;

const ConfirmationModal = ({
  dealerInfo,
  agencies,
  commercialOrder,
  disabled,
  onInvoiceClick,
}) => {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [agencySelected, setAgencySelected] = useState('');
  const dispatch = useDispatch();

  function fetchData() {
    const {dealerId} = dealerInfo;
    dispatch(fetchAgenciesByDealer({dealerId}));
    setModalIsOpen(true);
  }

  function getAgenciesOptions() {
    return agencies.map((item) => {
      return {'text': item.name, 'value': item.code};
    });
  }

  function onInvoiceModalClick() {
    onInvoiceClick(agencySelected);
    setModalIsOpen(false);
  }

  return (
    <Modal
      size='tiny'
      onOpen={() => fetchData()}
      className='accessories-invoicing-confirmation'
      open={modalIsOpen}
      trigger={
        <Button type='button' primary disabled={disabled}>
          Facturar
        </Button>
      }
    >
      <Modal.Header>
        {`¿Está seguro que desea facturar la orden comercial ${commercialOrder}?`}
      </Modal.Header>

      <Modal.Content>
        <Modal.Description>
          <p className='message'>
            Por favor seleccione estos campos obligatorios para proceder
          </p>
          <div>
            <h4>Agencia</h4>
            <Dropdown
              selection
              options={getAgenciesOptions()}
              search
              searchInput={{'autoFocus': true}}
              value={agencySelected}
              onChange={(e, {value}) => setAgencySelected(value)}
              placeholder='Seleccione tipo de factura'
              noResultsMessage='Agencia no encontrada'
            />
          </div>
        </Modal.Description>
      </Modal.Content>

      <Modal.Actions>
        <Button onClick={() => setModalIsOpen(false)}>Cancelar</Button>
        <Button
          positive
          disabled={!agencySelected}
          onClick={() => onInvoiceModalClick()}
        >
          Facturar
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export default ConfirmationModal;
